import { render, staticRenderFns } from "./otherSet.vue?vue&type=template&id=7480cb30&scoped=true"
import script from "./otherSet.vue?vue&type=script&lang=ts"
export * from "./otherSet.vue?vue&type=script&lang=ts"
import style0 from "./otherSet.vue?vue&type=style&index=0&id=7480cb30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7480cb30",
  null
  
)

export default component.exports